<div
  class="app-radio-group"
  [class.inline]="inline"
  [class.grid]="grid"
  [class.detailed]="detailed"
>
  <label *ngIf="label" class="form-label d-block">{{
    label | translate
  }}</label>

  <ng-container
    *ngFor="let option of options; let i = index; trackBy: trackByValue"
  >
    <label
      class="radio-container"
      [ngClass]="optionClass"
      [attr.for]="option.id || name + '_' + i"
      [attr.data-testid]="option.testId || null"
      [class.disabled]="disabled || option.disabled"
    >
      <i *ngIf="option.icon" [ngClass]="option.icon"></i>
      <ng-container *ngIf="option.label && !detailed">{{
        option.label | translate
      }}</ng-container>
      <span *ngIf="option.label && detailed" class="h5 d-block option-title">{{
        option.label | translate
      }}</span>
      <ng-container
        *ngIf="optionContentTpl"
        [ngTemplateOutlet]="optionContentTpl"
        [ngTemplateOutletContext]="{ $implicit: option }"
      ></ng-container>
      <input
        type="radio"
        [id]="option.id || name + '_' + i"
        [name]="name"
        [value]="option.value"
        [checked]="value === option.value"
        [disabled]="disabled || option.disabled"
        (change)="select(option.value)"
        (blur)="onTouched()"
      />
      <span
        class="checkmark"
        [attr.data-testid]="option.checkmarkTestId || null"
      ></span>
    </label>
    <app-explanation *ngIf="option.help && !detailed">
      <div *ngFor="let line of helpLines(option)">{{ line | translate }}</div>
    </app-explanation>
    <div *ngIf="option.help && detailed" class="option-details">
      <div *ngFor="let line of helpLines(option)">{{ line | translate }}</div>
    </div>
  </ng-container>

  <app-explanation *ngIf="helpText" [text]="helpText"></app-explanation>

  <div *ngIf="isInvalid && errorText" class="invalid-feedback d-block">
    <span>{{ errorText | translate }}</span>
  </div>
</div>
